import React, { useState } from 'react';
import FaqItem from '../FaqItem/FaqItem';
import './FaqAccordionSection.css';

const faqList = [
    /* ------------------ GENERAL ------------------ */
    {
        category: "general",
        question: "What is Vanidya?",
        answer:
            "Vanidya is a marketplace for Satvik groceries, organic staples, pooja essentials, and spiritual books. We connect customers with trusted local sellers offering products that align with mindful, culturally rooted lifestyles."
    },
    {
        category: "general",
        question: "How does Vanidya work?",
        answer:
            "Customers browse curated products from verified sellers, place orders through our app or website, and receive fast local delivery. Sellers manage listings, pricing, and fulfilment through their seller dashboard."
    },
    {
        category: "general",
        question: "Is Vanidya only for Satvik products?",
        answer:
            "Vanidya focuses on Satvik, vegetarian, organic, and ritual essentials. Products must meet our ingredient and transparency standards to be listed."
    },

    /* ------------------ CUSTOMERS ------------------ */
    {
        category: "customer",
        question: "Do I need an account to shop on Vanidya?",
        answer:
            "Yes. Creating an account ensures accurate delivery details, order tracking, and support availability."
    },
    {
        category: "customer",
        question: "How fast is delivery?",
        answer:
            "Delivery is typically same‑day or next‑day, depending on your location and your chosen seller’s fulfilment schedule."
    },
    {
        category: "customer",
        question: "Are products organic or Satvik certified?",
        answer:
            "Many products carry organic certification, while others follow Satvik or traditional preparation standards. Product pages clearly mention certification, ingredients, and sourcing info wherever the seller provides it."
    },
    {
        category: "customer",
        question: "Can I return or replace an item?",
        answer:
            "Yes. Returns and replacements are available for damaged, missing, incorrectly delivered, or poor‑quality items. Perishable and ritual‑use items follow specific guidelines listed in our return policy."
    },

    /* ------------------ SELLERS ------------------ */
    {
        category: "seller",
        question: "How can a seller join Vanidya?",
        answer:
            "Sellers can apply through our website. After a simple verification and quality check, businesses can start listing products, managing inventory, and fulfilling orders."
    },
    // {
    //     category: "seller",
    //     question: "Is there a platform fee?",
    //     answer:
    //         "No. Vanidya does not charge platform fees. Payments go directly from the customer to the seller."
    // },
    {
        category: "seller",
        question: "What products can I list as a seller?",
        answer:
            "Sellers may list Satvik groceries, organic staples, traditional foods, pooja items, home ritual essentials, and spiritual books—subject to approval."
    },
    {
        category: "seller",
        question: "Do sellers handle their own deliveries?",
        answer:
            "Yes. Sellers fulfill and deliver orders within their service areas. This ensures freshness and hyperlocal convenience."
    },

    /* ------------------ COMMUNITIES / GROUPS ------------------ */
    {
        category: "community",
        question: "Can housing societies or spiritual groups partner with Vanidya?",
        answer:
            "Yes. Vanidya provides curated catalogs and group‑ordering support for societies, cultural groups, and spiritual organizations based on their dietary and ritual preferences."
    },
    {
        category: "community",
        question: "What do community partnerships include?",
        answer:
            "Partnerships include customized product catalogs, bulk‑order assistance for festivals or events, delivery coordination, and dedicated support."
    },

    /* ------------------ APP / PLATFORM ------------------ */
    {
        category: "app",
        question: "Is there a Vanidya mobile app?",
        answer:
            "Yes. Customers can browse and place orders using the Vanidya mobile app, while sellers manage operations through the seller dashboard."
    },
    {
        category: "app",
        question: "Is my payment information secure?",
        answer:
            "Yes. Vanidya uses secure payment gateways. No financial information is stored on our servers."
    },

    /* ------------------ SUPPORT ------------------ */
    {
        category: "support",
        question: "How can I contact support?",
        answer: (
            <>
                You can reach our team at{" "}
                <a href="mailto:support@vanidya.com" className="faq-link">
                    support@vanidya.com
                </a>{" "}
                or through our{" "}
                <a href="/contact" className="faq-link">
                    Contact page
                </a>
                . We typically respond within a few business hours.
            </>
        ),
    },

    /* ------------------ EXTRA USEFUL QUESTIONS ------------------ */
    {
        category: "extra",
        question: "Are all sellers local?",
        answer:
            "Most sellers operate hyperlocally, offering fresh, reliable delivery. Select premium or specialty products may come from authenticated regional sellers."
    },
    {
        category: "extra",
        question: "Does Vanidya sell products directly?",
        answer:
            "No. Vanidya is a marketplace. Products are sold and delivered by independent, verified sellers."
    },
    {
        category: "extra",
        question: "Can I request products not listed on Vanidya?",
        answer:
            "Yes. You can suggest new product categories or brands through the feedback section in the app or via our support team."
    },
];

const FaqAccordionSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">


        <div className="faq-accordion">
          {faqList.map((faq, index) => (
            <FaqItem
              key={index}
              faq={faq}
              index={index}
              isOpen={openIndex === index}
              toggleFaq={toggleFaq}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqAccordionSection;